import { createPortal } from 'react-dom';

export function Modal({ open, title, subtitle, onClose, children, maxWidthClass = 'max-w-[960px]', className = '', showHeader = true }) {
  if (!open) return null;
  
  return createPortal(
    <div className="fixed inset-0 bg-slate-950/75 backdrop-blur-[18px] flex items-center justify-center p-6 z-[100]" role="dialog" aria-modal="true">
      <div className={`glass-xl w-full ${maxWidthClass} max-h-[90vh] overflow-y-auto p-8 ${className}`}>
        {showHeader && (
          <div className="flex items-start justify-between gap-4 mb-4">
            <div>
              <p className="uppercase tracking-[0.3em] text-[0.6rem] md:text-[0.65rem] text-text-muted">{subtitle}</p>
              <h2 className="text-xl md:text-2xl mt-1">{title}</h2>
            </div>
            <button className="ghost-pill w-9 h-9 inline-flex items-center justify-center bg-slate-900/60 border border-slate-600/60 text-text rounded-3xl cursor-pointer transition-all duration-200 hover:border-accent hover:text-sky-100" onClick={onClose} aria-label="关闭弹窗">
              ×
            </button>
          </div>
        )}
        {children}
      </div>
    </div>,
    document.body
  );
}
